import { useEffect } from "react";
import i18n from "./index";
import { AVAILABLE_LANGS } from "./languages";
import { loadNamespace } from "./index";

// Helper to validate and normalize a raw language value
function pick(raw) {
  if (!raw) return null;
  const base = raw.toLowerCase().split("-")[0];
  return AVAILABLE_LANGS.map((l) => l.code).includes(base) ? base : null;
}

/**
 * Auto-detekcja języka dla stron publicznych.
 * Priorytet: ?lang= -> localStorage(app.lang) -> navigator.language -> fallback.
 * Dodatkowo leniwie ładuje podane namespaces.
 */
export default function usePublicLocale(namespaces = []) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramLang = pick(params.get("lang"));
    const stored = pick(
      typeof localStorage !== "undefined"
        ? localStorage.getItem("app.lang")
        : null,
    );
    const nav = pick(
      typeof navigator !== "undefined" ? navigator.language : null,
    );
    const fallback = Array.isArray(i18n.options.fallbackLng)
      ? i18n.options.fallbackLng[0]
      : i18n.options.fallbackLng || "pl";

    const next = paramLang || stored || nav || fallback;

    if (paramLang && paramLang !== stored) {
      try {
        localStorage.setItem("app.lang", paramLang);
      } catch {}
    }
    if (i18n.language !== next) {
      i18n.changeLanguage(next);
    }

    namespaces.forEach((ns) => {
      if (!i18n.hasResourceBundle(next, ns)) {
        loadNamespace(ns, next);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search, namespaces.join("|")]);
}
